import React from 'react';
import PropTypes from 'prop-types';

import { InputWrapper, InputLabel, InputError } from 'components/atoms/styleds';
import Arrow from 'assets/images/backWhite.svg';
import DeletableItem from 'components/atoms/DeletableItem';

import {
  SelectDropdown,
  StyledSelectIcon,
  StyledSelectV2,
  StyledOptionV2,
} from './styled';

const Select = ({
  name,
  items,
  label,
  onChange,
  selectedKey,
  error,
  defaultLabel,
  fullWidth,
  mb,
  desktopMb,
  desktopMt,
  standardWidth = false,
  defaultValue,
  itemLabelKey = 'title',
  disabled,
  isArray
}) => {
  return (
    <InputWrapper
      height={44}
      fullWidth={fullWidth}
      mb={mb}
      desktopMt={desktopMt}
      desktopMb={desktopMb}
      standardWidth={standardWidth}
    >
      <InputLabel failed={!!error}>{label}</InputLabel>
      <StyledSelectV2
        failed={!!error}
        name={name}
        onChange={onChange}
        value={selectedKey}
        disabled={disabled}
        // defaultValue='DEFAULT'
      >
        {defaultLabel && (
          <StyledOptionV2 value={''} disabled='disabled'>
            {defaultLabel}
          </StyledOptionV2>
        )}

        {items?.map((i, index) => (
          <StyledOptionV2 key={i.id || index.toString()} value={isArray ? i : i.id}>
            {!isArray && (i.title || i[itemLabelKey])}
            {isArray && i}
          </StyledOptionV2>
        ))}
      </StyledSelectV2>
      <SelectDropdown>
        <StyledSelectIcon src={Arrow} />
      </SelectDropdown>
      {!!error && <InputError>{error}</InputError>}
    </InputWrapper>
  );
};

Select.propTypes = {
  name: PropTypes.string,
  items: PropTypes.array,
  label: PropTypes.string,
  selectedKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  showDefaultLabel: PropTypes.string,
  defaultValue: PropTypes.string,
  fullWidth: PropTypes.bool,
  standardWidth: PropTypes.bool,
  mb: PropTypes.number,
  desktopMb: PropTypes.number,
};

export default Select;
